<template>
  <div :class="['axiome-logique-container', 'axiome-logique-min-cardinality']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </div>
    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">min</span>


    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="minCardinalityLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
    </div>

  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeMinCardinality",
  computed: {
    minCardinalityLiterals() {
      let result = [];
      this.minCardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    minCardinality: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
